module.exports = __webpack_public_path__ + "img/school.cba00f5b.svg";